export default __webpack_public_path__ + "media/zurb/img/case-study-libdib/libdib-img2-47acecf39180d561fb8414af594d02df.png";